import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import HttpRunner from '../query';
import urlHandler from '../../../utils/urlHandler';
import perms from '../../../utils/permissions';
import examples from '../../../utils/examples';

class DocGeoEntity extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH)
        }) 
    }

    render() {
        return (
            <div className="bucket" id="top">
                <h3 className="heading-1">Geo</h3>
                <div className="description">
                    Finch For Text® has a comprehensive, global Gazetteer of over 30 
                    million geographic places. Because of this coverage, every extracted 
                    GEO entity will be disambiguated to a specific place.<br/>
                    <br/>
                    Each extracted GEO entity is returned with its preferred place name 
                    and associated markup information. An extracted GEO entity will be 
                    represented by the following attributes:
                </div>
                <table className="table-wrapper">
                    <thead className="table-header">
                    <tr>
                        <th>Attribute </th>
                        <th>Meaning </th>
                        <th>Type </th>
                    </tr>
                    </thead>
                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">label</td>
                        <td className="meaning">The preferred name of the location.
                        </td>
                        <td className="type">String</td>
                    </tr>
                    <tr>
                        <td className="attribute">score</td>
                        <td className="meaning">The confidence score indicating that the 
                            identified location is correct. A decimal number in the 0.0 to
                            1.0 range.
                        </td>
                        <td className="type">Decimal</td>
                    </tr>
                    <tr>
                        <td className="attribute">id</td>
                        <td className="meaning">The unique id from the Finch Knowledgebase</td>
                        <td className="type">Number</td>
                    </tr>
                    <tr>
                        <td className="attribute">location</td>
                        <td className="meaning">List of attributes associated with the disambiguated entity</td>
                        <td className="type"><a href="#geo_attributes_object">Location object</a></td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-3" id="geo_attributes_object">Location object</h4>
                <table className="table-wrapper">
                    <thead className="table-header">
                    <tr>
                        <th>Attribute </th>
                        <th>Meaning </th>
                        <th>Type </th>
                        <th>Constraints </th>
                        <th>Notes</th>
                    </tr>
                    </thead>
                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">dsgFeatureClass</td>
                        <td className="meaning">The feature class of the geographic location</td>
                        <td className="type">String</td>
                        <td className="constraints">Optional</td>
                        <td className="notes">
                            <Link to="/dsg_classes">See DSG feature classes</Link>
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">dsgFeatureCode</td>
                        <td className="meaning">The feature type designation code of the geographic location</td>
                        <td className="type">String</td>
                        <td className="constraints">Optional</td>
                        <td className="notes">
                            <Link to="/dsg_codes">See 'DSG Code' in Geographic Feature Types</Link>
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">latitude</td>
                        <td className="meaning">The latitude of the geographic location</td>
                        <td className="type">Number</td>
                        <td className="constraints">Optional</td>
                        <td className="notes">Expressed in decimal as WGS84<br/><br/>
                            Most GEO places with the exception of street addresses will have a latitude.
                        </td>

                    </tr>
                    <tr>
                        <td className="attribute">longitude</td>
                        <td className="meaning">The longitude of the geographic location</td>
                        <td className="type">Number</td>
                        <td className="constraints">Optional</td>
                        <td className="notes">Expressed in decimal as WGS84<br/><br/>
                            Most GEO places with the exception of street addresses will have a longitude.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">admin1Fips</td>
                        <td className="meaning">The FIPS region code of the enclosing ADMIN1 region (province)</td>
                        <td className="type">String</td>
                        <td className="constraints">Optional</td>
                        <td className="notes">
                            <Link to="/fips_codes">See FIPS Country and Province Codes</Link>
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">admin1Label</td>
                        <td className="meaning">The location&apos;s enclosing province name</td>
                        <td className="type">String</td>
                        <td className="constraints">Optional</td>
                        <td className="notes"> </td>
                    </tr>
                    <tr>
                        <td className="attribute">admin1Genc</td>
                        <td className="meaning">The location&apos;s GENC province code</td>
                        <td className="type">String</td>
                        <td className="constraints">Optional</td>
                        <td className="notes"> 
                            <Link to="/genc_codes">See GENC Province Codes</Link>
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">countryFips</td>
                        <td className="meaning">The FIPS country code of the enclosing country</td>
                        <td className="type">String</td>
                        <td className="constraints">Optional</td>
                        <td className="notes">
                            <Link to="/fips_codes">See FIPS Country and Province Codes</Link>
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">countryLabel</td>
                        <td className="meaning">The location&apos;s enclosing country name</td>
                        <td className="type">String</td>
                        <td className="constraints">Optional</td>
                        <td className="notes"> </td>
                    </tr>
                    <tr>
                        <td className="attribute">countryGencCode</td>
                        <td className="meaning">The location&apos;s GENC country numeric code</td>
                        <td className="type">String</td>
                        <td className="constraints">Optional</td>
                        <td className="notes"> 
                            <Link to="/genc_codes">See GENC Country Codes</Link>
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">countryGenc2</td>
                        <td className="meaning">The location&apos;s GENC country digraph</td>
                        <td className="type">String</td>
                        <td className="constraints">Optional</td>
                        <td className="notes"> 
                            <Link to="/genc_codes">See GENC Country Digraph Codes</Link>
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">countryGenc3</td>
                        <td className="meaning">The location&apos;s GENC country trigraph</td>
                        <td className="type">String</td>
                        <td className="constraints">Optional</td>
                        <td className="notes">
                            <Link to="/genc_codes">See GENC Country Trigraph Codes</Link>
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">population</td>
                        <td className="meaning">The population of the geographic location</td>
                        <td className="type">Number</td>
                        <td className="constraints">Optional</td>
                        <td className="notes"></td>
                    </tr>
                    <tr>
                        <td className="attribute">longForm</td>
                        <td className="meaning">The long form of the geo acronym, which describes the short form.</td>
                        <td className="type">String</td>
                        <td className="constraints">Optional</td>
                        <td className="notes"></td>
                    </tr>
                    <tr>
                        <td className="attribute">shortForm</td>
                        <td className="meaning">The short form of the geo acronym.</td>
                        <td className="type">String</td>
                        <td className="constraints">Optional</td>
                        <td className="notes"></td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-2">Examples</h4>

                <div className="example-content">Walmart is headquartered in Bentonville.</div>
                <HttpRunner example="geo1" 
                    query="enrich"
                    response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_GEO1) : null}
                />
                <br/>
                <div className="example-content">With the fall of Mosul, the impending 
                    capture of Raqqa, and the confirmed death of its leader, Abu Bakr 
                    al-Baghdadi, ISIL’s days as a caliphate are numbered. </div>
                <HttpRunner example="geo2" 
                    query="enrich"
                    response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_GEO2) : null}
                />
            </div>
        );
    }
}

export default DocGeoEntity;